/**
 * Flap CREATE2 vanity salt（TOKEN_TAXED_V3 → 地址后缀 7777）
 *
 * 站内发币 write → VaultPortal 0x9049…
 * 挖盐 CREATE2 deployer → 交易 Portal 0xe2cE…（VaultPortal 转发后由 Portal 部署）
 */
import { getContractAddress, keccak256, toBytes, toHex } from "viem";

const EIP1167_PREFIX = "0x3d602d80600a3d3981f3363d3d373d3d3d363d73";
const EIP1167_SUFFIX = "5af43d82803e903d91602b57fd5bf3";

/** BNB mainnet VaultPortal — newTokenV6WithVault 调用目标 */
export const FLAP_VAULT_PORTAL_56 =
  "0x90497450f2a706f1951b5bdda52B4E5d16f34C06";
/** 交易 Portal — CREATE2 盐值预测 */
export const FLAP_TRADE_PORTAL_56 =
  "0xe2cE6ab80874Fa9Fa2aAE65D277Dd6B8e65C9De0";

/** @deprecated 发币用 FLAP_VAULT_PORTAL_56；挖盐用 FLAP_TRADE_PORTAL_56 */
export const FLAP_PORTAL_56 = FLAP_VAULT_PORTAL_56;

export const TOKEN_IMPL_TAXED_V3_56 =
  "0x024f18294970B5c76c0691b87f138A0317156422";
export const VANITY_TAX_SUFFIX = "7777";

export function predictTokenAddress(salt, tokenImpl, portal) {
  const bytecode =
    `${EIP1167_PREFIX}${String(tokenImpl).slice(2).toLowerCase()}${EIP1167_SUFFIX}`;
  return getContractAddress({
    from: portal,
    salt: toBytes(salt),
    bytecode,
    opcode: "CREATE2",
  });
}

/** @returns {{ salt: `0x${string}`, address: `0x${string}`, iterations: number }} */
export function findVanityTaxSalt(
  portal = FLAP_TRADE_PORTAL_56,
  tokenImpl = TOKEN_IMPL_TAXED_V3_56,
  suffix = VANITY_TAX_SUFFIX
) {
  const seed =
    typeof crypto !== "undefined" && crypto.getRandomValues
      ? toHex(crypto.getRandomValues(new Uint8Array(32)))
      : toHex(
          Array.from({ length: 32 }, () => Math.floor(Math.random() * 256))
        );
  let salt = keccak256(seed);
  let iterations = 0;
  while (
    !predictTokenAddress(salt, tokenImpl, portal)
      .toLowerCase()
      .endsWith(suffix)
  ) {
    salt = keccak256(salt);
    iterations += 1;
    if (iterations > 5_000_000) {
      throw new Error("vanity salt search exceeded limit");
    }
  }
  return {
    salt,
    address: predictTokenAddress(salt, tokenImpl, portal),
    iterations,
  };
}

/** 分片挖盐，避免卡住创建中弹窗主线程 */
export async function findVanityTaxSaltAsync(
  onTick,
  portal = FLAP_TRADE_PORTAL_56,
  tokenImpl = TOKEN_IMPL_TAXED_V3_56,
  suffix = VANITY_TAX_SUFFIX
) {
  const seed =
    typeof crypto !== "undefined" && crypto.getRandomValues
      ? toHex(crypto.getRandomValues(new Uint8Array(32)))
      : toHex(
          Array.from({ length: 32 }, () => Math.floor(Math.random() * 256))
        );
  let salt = keccak256(seed);
  let iterations = 0;
  while (
    !predictTokenAddress(salt, tokenImpl, portal)
      .toLowerCase()
      .endsWith(suffix)
  ) {
    salt = keccak256(salt);
    iterations += 1;
    if (iterations > 5_000_000) {
      throw new Error("vanity salt search exceeded limit");
    }
    if (iterations % 2500 === 0) {
      onTick?.(iterations);
      await new Promise((r) => setTimeout(r, 0));
    }
  }
  return {
    salt,
    address: predictTokenAddress(salt, tokenImpl, portal),
    iterations,
  };
}
